import React, { useEffect, useState } from 'react';
import './App.css';

const LinkButton = ({ href, icon, label, color, hoverColor }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="link-button"
    style={{
      '--button-color': color,
      '--hover-color': hoverColor
    }}
    aria-label={label}
  >
    <i className={icon} aria-hidden="true"></i>
    <span>{label}</span>
  </a>
);

// const linksData = [
//   {
//     href: "https://facebook.com/f1rstmotors",
//     icon: "fab fa-facebook-f",
//     label: "Facebook",
//     color: "#1877F2",
//     hoverColor: "#166FE5"
//   },
//   {
//     href: "https://youtube.com/@f1rstmotors",
//     icon: "fab fa-youtube",
//     label: "YouTube",
//     color: "#FF0000",
//     hoverColor: "#E60000"
//   },
//   {
//     href: "https://instagram.com/f1rstmotors",
//     icon: "fab fa-instagram",
//     label: "Instagram",
//     color: "#E4405F",
//     hoverColor: "#D73653"
//   },
//   {
//     href: "https://f1rstmotors.com",
//     icon: "fas fa-globe",
//     label: "Website",
//     color: "#6366F1",
//     hoverColor: "#5856EB"
//   },
//   {
//     href: "https://www.linkedin.com/company/f1rst-motors/",
//     icon: "fab fa-linkedin-in",
//     label: "LinkedIn",
//     color: "#0A66C2",
//     hoverColor: "#095BB0"
//   },
//   {
//     href: "https://x.com/f1rstmotors",
//     icon: "fab fa-twitter",
//     label: "Twitter",
//     color: "#1DA1F2",
//     hoverColor: "#1A94DA"
//   }
// ]

function App() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getLinks = async () => {
      try {
        const res = await fetch(`https://api.konjac.ae/api/v3-1/en/settings/links`);
        if (!res.ok) throw new Error('Failed to load links');
        const data = await res.json();
        setLinks(Array.isArray(data?.data?.linksObjs) ? data.data.linksObjs : []);
      } catch (err) {
        setError('Unable to load links right now.');
      } finally {
        setLoading(false);
      }
    }
    getLinks();
  }, []) ;

  return (
    <div className="app">
      <div className="container" role="main">
        <div className="profile-section">
          <div className="profile-image">
            <div className="logo-badge" aria-hidden="true">
              <div className="logo-badge-ring"></div>
              <div className="logo-badge-inner"></div>
              <img
                className="logo-core"
                src="/logo.webp"
                alt="Konjac Skinfood Cosmetics Logo"
                width="180"
                height="180"
                loading="eager"
              />
            </div>
          </div>
          <p className="bio">Welcome to Konjac Skinfood Cosmetics digital hub! Connect with us across all platforms.</p>
        </div>

        <div className="links-section">
          {loading && (
            <>
              {[1,2,3,4].map((i) => (
                <div key={i} className="link-button shimmer" aria-hidden="true" style={{ height: 56 }} />
              ))}
            </>
          )}
          {!loading && !error && links.map((link, index) => (
            <LinkButton
              key={index}
              href={link.href}
              icon={link.icon}
              label={link.label}
              color={link.color}
              hoverColor={link.hoverColor}
            />
          ))}
          {!loading && error && (
            <div className="link-button" style={{ justifyContent: 'center', background: 'rgba(255,255,255,0.6)' }}>
              <span>{error}</span>
            </div>
          )}
        </div>

        <div className="footer">
          <p>© {new Date().getFullYear()} Konjac Skinfood Cosmetics. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default App;